import { Button, Grid, IconButton } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import { Add, Done, Edit } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import DoneIcon from '@material-ui/icons/Done';
import EditIcon from '@material-ui/icons/Edit';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { deleteStudentHobby } from '@webapps/business';
import { Modal, useMutation, useToast } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import AddInterest from './AddInterest';
import theme from './theme';

const {
  colors: { background },
} = theme;

const Interest = ({ hobbies = [], refetch }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [addInterest, setAddInterest] = useState(false);
  const [visibleDelete, setVisibleDelete] = useState(true);

  const handleDeleteVisible = () => {
    setVisibleDelete(!visibleDelete);
  };

  const handleOpenAddInterest = () => {
    setAddInterest(true);
  };
  const handleCloseAddInterest = () => {
    setAddInterest(false);
  };

  const { isSuccess: isSuccessDelete, mutateAsync: mutateDeleteHobby } =
    useMutation(deleteStudentHobby);

  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccessDelete) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
    }
  }, [isSuccessDelete]);

  const deleteHobby = async (id, visible) => {
    if (!visible) {
      await mutateDeleteHobby({
        id,
      });
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.editContainer}>
        <div className={global.title}>
          <FormattedMessage id="student.profil.interest.title" />{' '}
          {hobbies.length ? '(' + hobbies.length + ')' : ''}
        </div>
        <div style={{ display: 'flex' }}>
          <IconButton
            onClick={handleOpenAddInterest}
            size="small"
            style={{
              margin: 3,
              borderRadius: '20px',
              border: '1px solid #C0D9FF',
              backgroundColor: '#F3F7FF',
              width: '30px',
              display: 'flex',
              justifyContent: 'center',
              height: '30px',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <Add fontSize="small" style={{ color: '#5A6DA1' }} />
          </IconButton>
          {hobbies?.length > 0 && (
            <IconButton
              onClick={handleDeleteVisible}
              size="small"
              style={{
                margin: 3,
                borderRadius: '20px',
                border: '1px solid #C0D9FF',
                backgroundColor: '#F3F7FF',
                width: '30px',
                display: 'flex',
                justifyContent: 'center',
                height: '30px',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              {visibleDelete ? (
                <Edit fontSize="inherit" style={{ color: '#5A6DA1' }} />
              ) : (
                <Done fontSize="inherit" style={{ color: '#5A6DA1' }} />
              )}
            </IconButton>
          )}
        </div>
      </div>
      {hobbies?.length === 0 && (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
            display: 'flex',
            alignItems: 'start',
            justifyContent: 'center',
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      )}
      <div className={classes.badgeContainer}>
        {hobbies?.map(({ id, label }, index) => (
          <Badge
            key={index}
            badgeContent={
              <HighlightOffIcon color="secondary" fontSize="small" />
            }
            classes={{
              badge: css({ background: 'white', cursor: 'pointer' }),
            }}
            color="secondary"
            fullWidth
            invisible={visibleDelete}
            onClick={() => deleteHobby(id, visibleDelete)}
          >
            <div className={classes.labelContainer}>
              <div>{label}</div>
            </div>
          </Badge>
        ))}
      </div>
      <Modal
        onCancel={handleCloseAddInterest}
        open={addInterest}
        title={<FormattedMessage id="addInterest" />}
      >
        <AddInterest close={handleCloseAddInterest} refetch={refetch} />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background,
    borderRadius: 10,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 150,
  },
  editContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  badgeContainer: {
    marginTop: spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    columnGap: spacing(1.5),
    rowGap: spacing(1.5),
  },
  labelContainer: {
    backgroundColor: '#F3F7FF',
    borderRadius: 5,
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    paddingTop: spacing(1),
    paddingBottom: spacing(1),
    lineHeight: '100%',
    '& > *': {
      '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
      fontWeight: 400,
      color: '#152652',
    },
  },
});

Interest.propTypes = {
  hobbies: PropTypes.array,
  refetch: PropTypes.func,
};

export default Interest;
